import { v4 as uuidv4 } from "uuid";
import imageCompression from 'browser-image-compression';
import IndexedDBHelper from './IndexedDBHelper';
import OfflineSyncUtility from './OfflineSyncUtility';

// Initialize OfflineSyncUtility
OfflineSyncUtility.init();

/**
 * @param file - File or Blob to compress and store.
 * @param metadata - Optional metadata: can include workflow/task/component IDs or avatar/user info.
 * @returns An image record object stored in IndexedDB, with a generated blob URL.
 */

export const ProcessImageUpload = async (
  file,
  metadata = {}
) => {
  const options = {
    maxSizeMB: 0.65,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  const compressedFile = await imageCompression(file, options);
  const imageDocId = uuidv4();

  const imageRecord = {
    id: imageDocId,
    imageBlob: compressedFile,
    metadata,
    status: "stored_offline",
    url: URL.createObjectURL(compressedFile)
  };

  await IndexedDBHelper.addImage(imageRecord);

  return imageRecord;
};
